module.exports = __webpack_public_path__ + "static/media/profile.d7fa5dfd.png";